export enum StatusEnum {
    InWork = 1, // В работе
    Done = 2, // Выполнено
    Accept = 3, // Принято
    Approval = 4, // Согласование переноса срока
    Created = 5, // Создано
    Cancelled = 6, // Отменено
    Rejected = 7, // Отклонено
}

export enum StatusVersionEnum {
    Current = 1, // Текущая
    Approved, // Утвержденная
    Archive, // Архивная
    OnApproval, // на согласовании
    Rejected, // Отклонено
}
